import Immutable from 'immutable';
import Profile from './profile';

const CommentRecord = Immutable.Record({
  id: 0,
  author: Immutable.Map(),
  contents: Immutable.List(),
  createdAt: 0,
  hiddenProfile: false
});

class Comment extends CommentRecord {
  get text() {
    return this.contents.map(tv => tv.get('v')).join('');
  }

  get emoticons() {
    return this.contents.filter(tv => tv.get('t') == 'sticker')
      .map(tv => tv.get('v'));
  }
}

export default Comment;



// WEBPACK FOOTER //
// ./src/models/comment.js